import React, { useState, useEffect } from "react";
import { Transaction_SystemMessage } from "../../Connections/Transaction";
import ComponentBell from "../../Components/Common/ComponentBell";
import moment from "jalali-moment";

import "../../Styles/BellNotification.css";
import ComponentBellReceive from "./ComponentBellReceive";

const BellNotification = ({ isOpen, setIsOpen }) => {
  const [activeTab, setActiveTag] = useState("کتابنو");
  const [notificationList, setNotificationList] = useState([]);

  // =================================================

  const SystemMessages = () => {
    setActiveTag("ارسالی");
    setNotificationList([]);
    Transaction_SystemMessage.GetSystemMessages()
      .then((res) => {
        if (res[0]) {
          setNotificationList(res[2].data.sends);
        }
      })
      .catch((err) => console.log(err));
  };

  const SystemMessagesRecieves = () => {
    setActiveTag("دریافتی");
    setNotificationList([]);
    Transaction_SystemMessage.GetSystemMessages()
      .then((res) => {
        if (res[0]) {
          setNotificationList(res[2].data.recieves);
        }
      })
      .catch((err) => console.log(err));
  };

  const SystemKetabno = () => {
    setActiveTag("کتابنو");
    setNotificationList([]);
    Transaction_SystemMessage.GetSystemMessages()
      .then((res) => {
        if (res[0]) {
          setNotificationList(res[2].data.messages);
        }
      })
      .catch((err) => console.log(err));
  };

  //set first action in Bell
  useEffect(() => {
    SystemKetabno();
  }, []);

  // =================================================
  const [audioId, setAudioId] = useState(0);

  return (
    <div className={`BellNotification_wrapper ${isOpen ? "isOpen" : ""}`}>
      <div className="BellNotification_top">
        <div
          className="BellNotification_top_close"
          onClick={() => setIsOpen(false)}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#010a2b"
            />
          </svg>
        </div>
        <p>زنگوله</p>
        <img
          className="mobile-hidden"
          src="/imgs/Menu/Alert-dark.svg"
          alt="Alert icon"
        />
        <img
          className="desktop-hidden"
          src="/imgs/Menu/Alert.svg"
          alt="Alert icon"
        />
      </div>
      <ul className="BellNotification_tabs">
        <li
          className={activeTab == "دریافتی" ? "active" : ""}
          onClick={(e) => SystemMessagesRecieves()}
        >
          دریافتی
        </li>
        <li
          className={activeTab == "ارسالی" ? "active" : ""}
          onClick={(e) => SystemMessages()}
        >
          ارسالی
        </li>
        <li
          className={activeTab == "کتابنو" ? "active" : ""}
          onClick={(e) => SystemKetabno()}
        >
          کتابنو
        </li>
      </ul>
      {activeTab == "دریافتی" ? (
        <div className="BellNotification_no-content">
          {notificationList.map((item) => (
            <ComponentBellReceive
              id={item.id}
              key={item.id}
              icon={"/imgs/BellNotif/h.svg"}
              day={item.date}
              fullDate={item.createDate}
              text={item.postTitle}
              hashtags={[]}
              image={item.postFile}
              postType={item.postType}
              type={item.type}
              comment={item.comment}
              postUser={item.postUser}
              audioId={audioId}
              setAudioId={setAudioId}
            ></ComponentBellReceive>
          ))}
          {/* <img
                        className="BellNotification_no-content-img"
                        src="/imgs/Menu/bell_envelope.svg"
                        alt="bell_envelope"
                    />
                    <h3>هیچ لایک و کامنتی نداری!</h3> */}
        </div>
      ) : activeTab == "ارسالی" ? (
        <div className="BellNotification_content-send">
          {notificationList.map((item) => (
            <ComponentBell
              id={item.id}
              key={item.id}
              icon={"/imgs/BellNotif/h.svg"}
              day={item.date}
              fullDate={item.createDate}
              text={item.postTitle}
              hashtags={[]}
              image={item.postFile}
              postType={item.postType}
              type={item.type}
              comment={item.comment}
              postUser={item.postUser}
              audioId={audioId}
              setAudioId={setAudioId}
            ></ComponentBell>
          ))}
        </div>
      ) : activeTab == "کتابنو" ? (
        notificationList.map((item, index) => {
          return (
            <div key={index} className="BellNotification_content">
              <div className="BellNotification_content-ketabno">
                <div className="BellNotification_content-ketabno-header">
                  <div className="BellNotification_content-ketabno-profileBox">
                    <img
                      src="/imgs/BellNotif/support-image.svg"
                      alt="support profile"
                    />
                    <h3>پشتیبانی سایت</h3>
                  </div>
                  <span className="number-font">
                    {moment(item.date).locale("fa").format("YYYY/MM/DD")}
                  </span>
                </div>
                <div
                  className="BellNotification_content-text"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
              </div>
            </div>
          );
        })
      ) : null}
    </div>
  );
};

export default BellNotification;
